// /*--------------------------------------------------------------
// # Custom scripts for image slider block
// --------------------------------------------------------------*/

var imageSlider = jQuery('.image-slider');
// slick slider settings
var imageSliderSettings = {
    mobileFirst: true,
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span></button>',
    nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span></button>',
    adaptiveHeight: true
}

if (imageSlider.length > 0) {
    // set slides to same height
    // imageSlider.on('setPosition', function () {
    //     jQuery(this).find('.image-slider__item').height('auto');
    //     var slickTrack = jQuery(this).find('.slick-track');
    //     var slickTrackHeight = jQuery(slickTrack).height();
    //     jQuery(this).find('.image-slider__item').css('height', slickTrackHeight + 'px');
    // });

    // work out resize function to reinit or destroy slider on load and window resize
    jQuery(window).on('load resize', function() {        
        // init slider if not already initialised
        imageSlider.not('.slick-initialized').slick(imageSliderSettings);
    });

    // re init when in bootstrap tabbed content
    jQuery('[data-bs-toggle="tab"]').on('shown.bs.tab', function() {
        imageSlider.slick('setPosition');
    })
}
